import React, { useEffect } from 'react';
import { PlansGrid } from './PlansGrid';
import { useData } from '../../../data-layer';
import { LayoutType } from '../../../API';

export function Plans(): React.ReactElement {
  const { plans, coupons, pages } = useData();

  // PlansGrid fetches its own page of plans, but the full list still backs the
  // promo group picker on PlanForm. Coupons back the grid's CouponBadge and
  // PlanForm's CouponPicker, and the promo pages back its TemplateIdPicker --
  // both of those render nothing at all when their dataset is missing.
  useEffect(() => {
    plans.hook.getAll();
    coupons.hook.getAll();
    pages.hook.getBucket(LayoutType.PROMOS);
  }, []);

  return <PlansGrid />;
}
